/* eslint-disable react-hooks/exhaustive-deps */
import React, { forwardRef, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";

/** Utilities */
import { decryptUrlData } from "../../../services/CryptoService";

/** Common Components */
import CardSection from "../../../components/ui/card/CardSection";
import CenterModel from "../../../components/ui/centerModel/CenterModel";

/** Common Services & Data Files */
import SwalAlert from "../../../services/swalService/SwalService";
import ToastService from "../../../services/toastService/ToastService";

/** RTK Query */
import {
  useDeleteProjectStatusMutation,
  useGetProjectStatusWithPaginationMutation,
} from "../../../app/services/projectStatusAPI";

/** Lazily Loaded Components */
import AddDefaultStatus from "./ProjectStatus/AddDefaultStatus";
import AddProjectStatus from "./ProjectStatus/AddProjectStatus";
import ProjectStatusTable from "./ProjectStatus/ProjectStatusTable/ProjectStatusTable";
import ProjectStatusTest from "./projectStatusTest/ProjectStatusTest";

const ProjectStatus = forwardRef((props, ref) => {
  const molGridRef = useRef();
  /* State*/
  const [showModal, setShowModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [projectStatusGridData, setProjectStatusGridData] = useState([]);
  const { confirm, error } = SwalAlert();
  const { id } = useParams();
  let projectId = null;
  const projectIdData = id ? decryptUrlData(id) : 0;
  if (typeof projectIdData === "object" && projectIdData !== null) {
    projectId = projectIdData.projectId;
  } else if (projectIdData) {
    projectId = projectIdData;
  }
  // API'S Call
  const [getAllProjectStatusList, {
    isLoading: isProjectStatusListLoading,
    isSuccess: isProjectStatusListSuccess,
    data: isLProjectStatusListeData,
  },] = useGetProjectStatusWithPaginationMutation();
  
  const [deleteProjectStatus, {
    isSuccess: isProjectStatusDeleted,
    data: deleteProjectStatusData
  },] = useDeleteProjectStatusMutation();

  //** useEffect's */
  useEffect(() => {
    getProjectDataList();
  }, []);

  useEffect(() => {
    if (isProjectStatusListSuccess && isLProjectStatusListeData) {
      setProjectStatusGridData(isLProjectStatusListeData.dataSource);
    }
  }, [isProjectStatusListSuccess, isLProjectStatusListeData]);

  useEffect(() => {
    if (isProjectStatusDeleted && deleteProjectStatusData) {
      ToastService.success(deleteProjectStatusData.errorMessage);
      getProjectDataList();
    }
  }, [isProjectStatusDeleted, deleteProjectStatusData]);

  //** Funcation's */
  const handleToggleModal = () => {
    setIsModelOpen(true);
  };

  const getProjectDataList = () => {
    const request = {
      pagination: {
        pageNumber: 1,
        pageSize: 1000,
      },
      projectId: projectId,
    };
    getAllProjectStatusList(request);
  };

  const onDeleteClick = (data) => {
    if (data.isDefault === true) {
      error(
        "You cannot delete this status because it is set as the default.",
        "error",
        " "
      );
    } else {
      confirm(
        "Delete?",
        "Are you sure you want to Delete?",
        "Delete",
        "Cancel"
      ).then((confirmed) => {
        if (confirmed) {
          deleteProjectStatus(data.projectStatusConfigurationId);
        }
      });
    }
  };

  const onEditAction = (data) => {
    setSelectedId(data.projectStatusConfigurationId);
    setIsModelOpen(true);
  };

  const onSidebarClose = () => {
    setIsModelOpen(false);
    setSelectedId(null);
  };

  const AddhandleToggleModal = () => {
    setShowModal(!showModal);
    if (molGridRef.current) {
      getProjectDataList();
    }
  };

  return (
    <div className="table-style">
      <div className="project-Status center-top-space">
        {/* Filter Section Start */}
        <CardSection
          isContentLoading={isProjectStatusListLoading}
          cardTitle={"Project Status"}
          rightButton={true}
          buttonClassName="theme-btn"
          titleButtonClick={handleToggleModal}
          buttonText="Status"
          textWithIcon={true}
          iconName="material-symbols:add-rounded"
          fontIcon={true}
          // searchInputName="Search"
          // searchInput={true}
          multipleButton={true}
          rightButtonArray={[
            {
              buttonTypeClassName: "theme-btn mr-2",
              onClick: AddhandleToggleModal,
              buttonText: "Default Status",
              textWithIcon: true,
              fontIcon: true,
              iconName: "material-symbols:add-rounded",
            },
          ]}
        >
          {/* Filter Section End */}
          <div className="table-grid">
            <ProjectStatusTable
              initialData={projectStatusGridData}
              onDeleteClick={onDeleteClick}
              onEditAction={onEditAction}
            />
          </div>
        </CardSection>
        <ProjectStatusTest projectId={projectId} selectedId={selectedId} />
      </div>
      <div>
        {isModelOpen && (
          <CenterModel
            showModal={isModelOpen}
            handleToggleModal={onSidebarClose}
            modalTitle={selectedId ? "Update Status" : "Add Status"}
            modelSizeClass="w-40"
          >
            <AddProjectStatus
              getProjectDataList={getProjectDataList}
              onSidebarClose={onSidebarClose}
              showModal={isModelOpen}
              selectedId={selectedId}
              projectId={projectId}
            />
          </CenterModel>
        )}
      </div>
      <div>
        {showModal && (
          <CenterModel
            showModal={showModal}
            handleToggleModal={AddhandleToggleModal}
            modalTitle="Take Over Default Status"
            modelSizeClass="w-30"
          >
            <AddDefaultStatus
              projectId={projectId}
              onClose={AddhandleToggleModal}
              getProjectDataList={getProjectDataList}
            />
          </CenterModel>
        )}
      </div>
    </div>
  );
});

export default ProjectStatus;
